export const Footer = () => {
  return (
    <footer className="mt-16 border-t border-border/60 bg-white" data-testid="app-footer">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-3 px-4 py-6 text-sm text-muted-foreground sm:flex-row sm:items-center sm:px-6 lg:px-8">
        <div className="flex items-center gap-2">
          <img src="/urjapod-logo.png" alt="UrjaPod" className="h-9 w-auto" />
          <span>&copy; {new Date().getFullYear()} UrjaPod Energy · Battery Energy Storage</span>
        </div>
        <div className="flex items-center gap-4">
          <span>Physics-based sizing</span>
          <span className="h-1 w-1 rounded-full bg-border" />
          <span>Your data stays private</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
